var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#EC4652"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.635 9.448a.838.838 0 00-1.19 0 .844.844 0 000 1.19l3.368 3.384-3.324 3.34a.844.844 0 000 1.19c.328.33.86.33 1.189 0L14 15.216l3.322 3.338c.328.33.861.33 1.19 0a.845.845 0 000-1.19l-3.325-3.341 3.368-3.384a.845.845 0 000-1.19.838.838 0 00-1.19 0L14 12.829l-3.365-3.381z",
    fill: "#fff"
  })));
}
export default SvgError;